import script from "./ModerationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ModerationPage.vue?vue&type=script&setup=true&lang=js"

import "./ModerationPage.vue?vue&type=style&index=0&id=7961b164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7961b164"]])

export default __exports__